import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Checkbox,
  Box,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import dayjs from "dayjs";

import { useFormik } from "formik";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import Swal from "sweetalert2";
import "assets/css/modal.css";
import SaveIcon from "assets/images/SaveIcon.svg";
import { Switch } from "antd";

const roleOption = [
  { label: "เจ้าของร้าน", id: 2 },
  { label: "หัวหน้าแอดมินการอนุมัติ", id: 3 },
  { label: "หัวหน้าแอดมินการจัดการ", id: 4 },
  { label: "แอดมินการอนุมัติ", id: 5 },
  { label: "แอดมินการจัดการ", id: 6 },
];

const productFields = [
  { label: "เงินตั้งต้น", name: "budget", type: "text" },
  {
    label: "เวลาเปิดร้าน",
    name: "open_time",
    type: "text",
  },
  {
    label: "เวลาปิดร้าน",
    name: "close_time",
    type: "text",
  },
  {
    label: "ที่อยู่สำหรับติดต่อใน MarketPlace",
    name: "marketplace_address",
    type: "text",
  },
];

const ModalSettingCompany = ({ open, onClose, companyId }) => {
  const [fetchCompanyData, setFetchCompanyData] = useState();

  // console.log("checking picture display in modal", initialProductUrls);

  const fetchCompany = async () => {
    const company = await api.super_admin.getCompanyData(companyId);
    if (company.isStatus) {
      setFetchCompanyData({
        budget: company.data.budget,
        open_time: company.data.open_time,
        close_time: company.data.close_time,
        marketplace_address: company.data.marketplace_address,
        remaining_budget: company.data.remaining_budget,
      });
      formik.setValues({
        budget: fetchCompanyData?.budget,
        open_time: fetchCompanyData?.open_time,
        close_time: fetchCompanyData?.close_time,
        marketplace_address: fetchCompanyData?.marketplace_address,
        remaining_budget: company.data.remaining_budget,
      });
    }
  };
  useEffect(() => {
    fetchCompany();
  }, [open]);

  // Function to transform object to FormData
  const tranFormObjectToFormData = (obj) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (key === "company_type_id" && typeof value === "object" && value.id) {
        formData.append(key, value.id);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === "object" && item !== null) {
            formData.append(`${key}[${index}]`, JSON.stringify(item));
          } else {
            formData.append(`${key}[${index}]`, item);
          }
        });
      } else if (key === "files" && Array.isArray(value)) {
        value.forEach((file, index) => {
          formData.append(`files[${index}]`, file);
        });
      } else {
        formData.append(key, value !== undefined ? value : ""); // Ensure undefined values are not passed
      }
    });

    // Log formData for debugging
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    return formData;
  };

  // Formik setup
  const formik = useFormik({
    initialValues: {
      budget: fetchCompanyData?.budget ?? "",
      remaining_budget: fetchCompanyData?.remaining_budget ?? "",
      open_time: fetchCompanyData?.open_time ?? "",
      close_time: fetchCompanyData?.close_time ?? "",
      marketplace_address: fetchCompanyData?.marketplace_address ?? "",
    },
    validate: (values) => {
      const errors = {};
      if (values.budget < fetchCompanyData?.remaining_budget) {
        errors.budget = "กรุณากรอกเงินตั้งต้นมากกว่ายอดคงเหลือ";
      }
      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      let increaseBudget = 0;
      if (
        fetchCompanyData?.remaining_budget > 0 &&
        values.budget > fetchCompanyData?.remaining_budget
      ) {
        increaseBudget = values.budget - fetchCompanyData?.budget;
      }
      const company = {
        budget: values.budget,
        remaining_budget: fetchCompanyData?.remaining_budget
          ? fetchCompanyData?.remaining_budget + increaseBudget
          : values.budget,
        open_time: values.open_time,
        close_time: values.close_time,
        marketplace_address: values.marketplace_address,
      };

      // Proceed with your API call
      //
      try {
        const companyResponse = await api.super_admin.CompanySetting(
          companyId,
          company
        );

        if (companyResponse.isStatus) {
          resetForm();
          onClose();
          fetchCompany();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert(`Error submitting form: ${error.message}`);
      }
    },
  });

  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  onClose(); // Close the modal
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      onClose();
    }
  };

  const renderFields = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">
            {field.label}
            {field.required && (
              <span style={{ marginLeft: "4px", color: "red" }}>*</span>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={10}>
          {field.type === "autocomplete" ? (
            <Autocomplete
              id={field.name}
              options={roleOption}
              getOptionLabel={(option) => option.label}
              value={formik.values.role_id}
              onChange={(event, newValue) => {
                if (!field.disabled) {
                  formik.setFieldValue("role_id", newValue);
                }
              }}
              disabled={field.disabled}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{
                ".MuiAutocomplete-inputRoot": {
                  height: "40px",
                  padding: "0px 0px 0px 5px !important",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name={field.name}
                  error={
                    formik.touched[field.name] &&
                    Boolean(formik.errors[field.name])
                  }
                  helperText={
                    formik.touched[field.name] && formik.errors[field.name]
                  }
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    sx: { height: "40px" },
                  }}
                />
              )}
            />
          ) : field.type === "checkbox" ? (
            <Switch
              value={formik.values.status}
              onChange={(checked) => {
                if (!field.disabled) {
                  formik.setFieldValue("status", checked);
                }
              }}
            />
          ) : field.name == "open_time" || field.name == "close_time" ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimeField
                label={`${
                  field.name == "open_time" ? "เวลาเปิดร้าน" : "เวลาปิดร้าน"
                }`}
                value={
                  formik.values[field.name]
                    ? dayjs(formik.values[field.name], "HH:mm:ss")
                    : null
                }
                format="HH:mm:ss"
                onChange={(newValue) => {
                  const formattedTime = newValue
                    ? newValue.format("HH:mm:ss")
                    : "";
                  formik.setFieldValue(field.name, formattedTime);
                }}
              />
            </LocalizationProvider>
          ) : (
            <TextField
              disabled={field.disabled}
              id={field.name}
              name={field.name}
              type={field.type}
              value={formik.values[field.name]}
              onChange={formik.handleChange}
              {...getFieldProps(field.name)}
              error={
                formik.touched[field.name] && Boolean(formik.errors[field.name])
              }
              helperText={
                formik.touched[field.name] && formik.errors[field.name]
              }
              fullWidth
              InputProps={{
                sx: { height: "40px" },
                inputProps: {
                  style: {
                    "-moz-appearance": "textfield", // Hide up/down arrows in Firefox
                    "-webkit-appearance": "none", // Hide up/down arrows in Chrome/Safari
                    appearance: "none", // Hide up/down arrows in other browsers
                  },
                  // maxLength:
                  //   field.name === "amphure_id"
                  //     ? 13
                  //     : field.name === "district_id"
                  //     ? 10
                  //     : undefined, // Set max length
                  inputMode: field.type === "text" ? "numeric" : undefined, // Ensure numeric keyboard on mobile
                  pattern: field.type === "text" ? "[0-9]*" : undefined, // Restrict input to numbers
                },
              }}
            />
          )}
        </Grid>
      </React.Fragment>
    ));
  };

  // console.log("formik.values display ", formik.values);

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogTitle>
        <Typography variant="h4">ตั้งค่าบริษัท</Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} sx={{ padding: 3 }}>
            <Grid item xs={12}>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {renderFields(productFields)}
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={handleCancel}
        >
          ยกเลิก
        </GradientButtonOutline>
        <GradientButton
          variant="contained"
          onClick={formik.handleSubmit}
          type="submit"
        >
          บันทึก
        </GradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSettingCompany;
